const LatestMessageStatus = {
  OPENED: 'Opened',
  DELIVERED: 'Delivered',
  NOT_DELIVERED: 'Not Delivered',
  REJECTED: 'Rejected',
  UNKNOWN: 'Unknown',
};

export default LatestMessageStatus;
